export default __webpack_public_path__ + "fonts/icon-fonts.013a7168cc77c879018014e55a237229.png";